import { GridColumns } from '@visx/grid';
import AnimatedGridLines from "./AnimatedGridLines.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedGridColumns(_ref) {
  let {
    scale,
    height,
    numTicks,
    tickValues,
    offset,
    className,
    animationTrajectory,
    top,
    left,
    ...lineProps
  } = _ref;
  return /*#__PURE__*/_jsx(GridColumns, {
    scale: scale,
    height: height,
    numTicks: numTicks,
    tickValues: tickValues,
    className: className,
    offset: offset,
    top: top,
    left: left,
    children: _ref2 => {
      let {
        lines
      } = _ref2;
      return /*#__PURE__*/_jsx(AnimatedGridLines, {
        scale: scale,
        lines: lines,
        animationTrajectory: animationTrajectory,
        animateXOrY: "x",
        lineKey: line => `column-${line?.from?.x ?? ''}-${line.index}`,
        ...lineProps
      });
    }
  });
}